var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 478.229 478.229",
    style: {
      enableBackground: "new 0 0 478.229 478.229"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c8cc6"
    },
    d: "M399.727,465.513c-40,39.2-158.4-15.2-264.8-122.4c-107.2-106.4-161.6-224.8-121.6-264.8 c39.2-39.2,77.6,95.2,184,202.4C303.727,387.113,438.927,425.513,399.727,465.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6190d6"
    },
    d: "M197.327,280.713c106.4,106.4,241.6,144.8,202.4,184c-40,40-158.4-14.4-264.8-121.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c8cc6"
    },
    d: "M138.127,155.113c-30.4,20.8-77.6,4.8-105.6-36c-28-40-25.6-90.4,4.8-111.2s68,1.6,96,41.6 C161.327,91.113,168.527,134.313,138.127,155.113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6190d6"
    },
    d: "M133.327,50.313c28,40.8,35.2,84,4.8,104.8s-77.6,4.8-105.6-36"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#166eb5"
    },
    d: "M151.727,139.913c12.8-23.2,3.2-57.6-18.4-89.6c-21.6-31.2-49.6-52-75.2-49.6 c-13.6,12-4,50.4,20.8,87.2C103.727,123.913,134.927,145.513,151.727,139.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c8cc6"
    },
    d: "M322.927,339.913c-20.8,30.4-4.8,77.6,36,105.6s90.4,26.4,111.2-4c20.8-30.4-1.6-68.8-41.6-96 C386.927,316.713,343.727,309.513,322.927,339.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6190d6"
    },
    d: "M358.927,445.513c40.8,28,90.4,26.4,111.2-4c20.8-30.4-1.6-68.8-41.6-96"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#166eb5"
    },
    d: "M338.127,326.313c23.2-12.8,57.6-3.2,89.6,18.4c31.2,21.6,52,49.6,49.6,75.2 c-12,13.6-50.4,4.8-87.2-20.8C354.127,374.313,332.527,343.113,338.127,326.313z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallMain);
export default __webpack_public_path__ + "static/media/callMain.e472a2bf21bf4c9efbc7ef8595bc6342.svg";
export { ForwardRef as ReactComponent };